import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';
import Form from "../../../components/form/Form";
import {useAuth} from "../../../providers/AuthProvider";

const OppRejectionFeedbackModal = props => {

    const form = useRef(null);
    const [rejectModel, setRejectModel] = useState({});

    const {auth} = useAuth();
    const submittingAsSupplier = auth?.canManageClientResourceTalent();

    let reasons = TB.trans('talent.opportunity_rejection_reasons');

    const options = TB.reduce(reasons, (result, label, value) => {
        if (TB.isString(label) && label.length > 0){
            result.push({label: submittingAsSupplier ? TB.replace(label,'I\'m', 'The talent is') : label, value});
        }
        return result;
    }, [])

    return (
        <div>

            <Form
                ref={form}
                className="default-form opp-reject-feedback-form"
                onSubmit={model => console.log('onModalSubmit', model)}
                submitButton={false}
                cancelButton={false}
                background={'none'}
                model={rejectModel}
                isDisabled={props.disabled}
                onChange={model => setRejectModel(model)}
                fields={[
                    {
                        style: {flexDirection: 'row'},
                        fields: {
                            rejection_reason: {
                                type: 'radio',
                                required: true,
                                options,
                                label: 'Please select a reason',
                                columns: 5,
                                className: 'reject-reason-input'
                            },
                            rejection_reason_notes: {
                                type: 'textarea',
                                rows: 6,
                                required: false,
                                label: false,
                                placeholder: 'Tell us a little more...',
                                columns: 7,
                                className: 'field reject-reason-notes-input'
                            }
                        }
                    }
                ]}>


                <div className="reject-reason-actions">

                    <button type="button" onClick={props.onCancel}
                            disabled={props.disabled} className="btn btn-link btn-link-danger">
                        Cancel
                    </button>



                    <button type="button" disabled={props.disabled} onClick={async() => {
                        let invalid = form.current.forceValidate();
                        if (!invalid) {
                            props.onSubmit({
                                ...rejectModel,
                                rejected_at: TB.moment().toISOString()
                            })
                        }
                    }} className="btn btn-primary ml-0 mr-0 md:mr-3 md:ml-auto">
                        Continue
                    </button>

                    <button type="button" onClick={() => {
                        props.onSubmit({rejected_at: TB.moment().toISOString()})
                    }} disabled={props.disabled} className="btn btn-outline-dark">
                        Skip
                    </button>
                </div>

            </Form>

        </div>
    );
};

OppRejectionFeedbackModal.propTypes = {
    onSubmit: PropTypes.func
};

export default OppRejectionFeedbackModal;